module.exports = window.T['undefined/log.html'] || "<logviewer log=\"log\" jump-to-line=\"jumpToLine\"></logviewer>";